import { Modal } from "@9amhealth/shared";
import styled from "@emotion/styled";
import React, { FC, useEffect } from "react";
import { tracker } from "src/state/state";
import { TrackingData } from "src/state/Track/TrackCubit";

const SheetContent = styled.div`
  label: SheetContent;
  padding: 2rem 1.6rem calc(var(--safe-area-inset-bottom) + 3rem);
`;

interface BottomSheetProps {
  isOpen: boolean;
  onClose: () => unknown | Promise<unknown>;
  children?: React.ReactNode;
  trackingName?: string;
  trackingData?: TrackingData;
}

export const BottomSheet: FC<BottomSheetProps> = ({
  isOpen,
  onClose,
  children,
  trackingName,
  trackingData
}) => {
  useEffect(() => {
    if (!trackingName) {
      return;
    }
    if (isOpen) {
      tracker.track(`${trackingName} Opened`, { data: trackingData ?? {} });
    } else {
      tracker.track(`${trackingName} Closed`, { data: trackingData ?? {} });
    }
  }, [isOpen, trackingName, trackingData]);

  return (
    <Modal variant="sheet" isOpen={isOpen} onDidDismiss={() => void onClose()}>
      <SheetContent>{children}</SheetContent>
    </Modal>
  );
};
